<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light" class="mt-3">

                <b-row class="my-3 align-items-center">
                    <b-col cols='10'>
                    </b-col>
                    <b-col cols='2' class='d-flex justify-content-center align-items-center'>
                        <b-button id="nova-carona" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            @click="showModalNovaCarona" variant="primary">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                            <b-tooltip target="nova-carona" title="Adicionar nova..." triggers="hover"></b-tooltip>
                        </b-button>
                    </b-col>
                </b-row>
                <b-table responsive class="mt-2" small show-empty :busy="busy" :items="records" :fields="fields" hover>
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <ConsultarAtasForm @close="fecharModalNovaCarona" :isCarona="true" :idAta="ata" :isViewMode="true"
            v-if="mostrarModalNovaCarona" :prefix="prefix + title + ' > '"></ConsultarAtasForm>
    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import { ListResourceMixin } from "@/core/mixins/resource";
import ConsultarAtasForm from "./ConsultarAtasForm.vue";
export default {
    components: {
        ConsultarAtasForm
    },
    mixins: [ListResourceMixin],

    props: {
        ata: Number,
        prefix: {
            type: String,
            default: ""
        },
        statusId: Number,
        processoId: Number,
        status: {
            type: Number,
            default: null,
        },
        consultaDetalhada: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            mostrarModalNovaCarona: false,
            isViewMode: false,
            mostrarModalForm: false,
            title: "Consultar Carona",
            fields: [
                { key: "empresa.dadosEmpresa.razaoSocial", label: "Participante" },
                { key: "quantidadeItensCarona", label: "Quantidade de Itens da Carona" },
            ],
            currentPage: 1,
            perPage: 10,
            totalPages: 1,
            busy: false,
            perPageOptions: [5, 10, 25, 50],
        }
    },
    watch: {
        page() {
            this.load()
        },
    },
    beforeMount() {
        this.$service = new ResourceService(`/api/participantes-ata`);

        this.load()
    },
    methods: {
        showModalNovaCarona() {
            this.mostrarModalNovaCarona = true;
        },

        fecharModalNovaCarona() {
            this.mostrarModalNovaCarona = false;
            this.load();
        },
        async load() {
            this.busy = true
            this.filtro = {};

            this.filtro.ata = this.ata;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,

            });

            this.busy = false;

        },
        clickMostrarModalForm() {
            this.autorizacaoFornecedorId = null;
            this.isViewMode = false;
            this.mostrarModalForm = true;
        },
        fecharModalForm() {
            this.isViewMode = false;
            this.mostrarModalForm = false;
        }
    },
}
</script>

<style scoped>
.badge {
    font-size: 85% !important;
    padding: 5px 10px !important;
}

.btn-size-alinhamento {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
